/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Trim_Duration_TitleInputs */

const en_event_ad_trim_duration_title = /** @type {(inputs: Event_Ad_Trim_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim or extend the event duration based on the virtual audio duration`)
};

const fr_event_ad_trim_duration_title = /** @type {(inputs: Event_Ad_Trim_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccourcir ou prolonger la duree de l'evenement en fonction de la duree de l'audio virtuel`)
};

const de_event_ad_trim_duration_title = /** @type {(inputs: Event_Ad_Trim_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kürzen oder verlängern Sie die Ereignisdauer basierend auf der virtuellen Audiodauer.`)
};

const it_event_ad_trim_duration_title = /** @type {(inputs: Event_Ad_Trim_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridurre o estendere la durata dell'evento in base alla durata dell'audio virtuale`)
};

const ru_event_ad_trim_duration_title = /** @type {(inputs: Event_Ad_Trim_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обрежьте или увеличьте продолжительность события в зависимости от виртуальной продолжительности звука.`)
};

const es_event_ad_trim_duration_title = /** @type {(inputs: Event_Ad_Trim_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortar o ampliar la duración del evento en función de la duración del audio virtual`)
};

const zh_cn2_event_ad_trim_duration_title = /** @type {(inputs: Event_Ad_Trim_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据虚拟音频时长调整活动持续时间。`)
};

const ja_event_ad_trim_duration_title = /** @type {(inputs: Event_Ad_Trim_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仮想オーディオの長さに基づいてイベントの長さを調整または延長します`)
};

const hi_event_ad_trim_duration_title = /** @type {(inputs: Event_Ad_Trim_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्चुअल ऑडियो की अवधि के आधार पर इवेंट की अवधि को छोटा या लंबा करें।`)
};

const pt_pt2_event_ad_trim_duration_title = /** @type {(inputs: Event_Ad_Trim_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste a duração do evento com base na duração do áudio virtual.`)
};

/**
* | output |
* | --- |
* | "Trim or extend the event duration based on the virtual audio duration" |
*
* @param {Event_Ad_Trim_Duration_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_trim_duration_title = /** @type {((inputs?: Event_Ad_Trim_Duration_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Trim_Duration_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_trim_duration_title(inputs)
	if (locale === "de") return de_event_ad_trim_duration_title(inputs)
	if (locale === "it") return it_event_ad_trim_duration_title(inputs)
	if (locale === "ru") return ru_event_ad_trim_duration_title(inputs)
	if (locale === "es") return es_event_ad_trim_duration_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_trim_duration_title(inputs)
	if (locale === "ja") return ja_event_ad_trim_duration_title(inputs)
	if (locale === "hi") return hi_event_ad_trim_duration_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_trim_duration_title(inputs)
	return en_event_ad_trim_duration_title(inputs)
});